// API Configuration for development and production
const API_CONFIG = {
  // In development, use the proxy (empty string for relative paths)
  // In production, use the absolute API domain
  BASE_URL: process.env.NODE_ENV === 'production' 
    ? (process.env.REACT_APP_API_URL || 'https://api.useturret.com')
    : '', // Empty string for relative paths in development (uses proxy)
  
  // Version prefix
  VERSION: '/api/v1'
};

// Helper function to build API URLs
export const buildApiUrl = (endpoint: string): string => {
  // Remove leading slash if present to avoid double slashes
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  
  if (API_CONFIG.BASE_URL) {
    // Production: use absolute URL
    return `${API_CONFIG.BASE_URL}/${cleanEndpoint}`;
  } else {
    // Development: use relative URL (proxy will handle it)
    return `/${cleanEndpoint}`;
  }
};

// Export the config for direct access if needed
export default API_CONFIG; 